/** Original fictional Year 10 example. This is not a reviewed exam-bank record. */
export const DEMO_BANK_QUESTION = {
  id: 'b1b02026-1018-4010-8000-000000000001',
  stem: 'Solve x² − 5x + 6 = 0. Which pair gives both solutions?',
  options: ['−2 and −3', '1 and 6', '2 and 3', '−1 and −6'],
  answer: 'C',
  hint: 'Find two numbers whose product is 6 and whose sum is −5. Then use the zero-product rule.',
  solution:
    '1. Find two numbers that multiply to 6 and add to −5: −2 and −3.\n2. Factor: x² − 5x + 6 = (x − 2)(x − 3).\n3. A product is zero when at least one factor is zero. So x − 2 = 0 or x − 3 = 0: x = 2 or x = 3.\n4. Check both: 2² − 5×2 + 6 = 0 and 3² − 5×3 + 6 = 0. The negative options fail substitution.',
};
